import styled, { css } from 'styled-components';
import { Typography } from '../Typography';
import { EllipsisText } from '../../../styled/common';
import { ButtonType } from '../../../styled/theme/types';
import { ThemeType } from '../../../styled/theme/constants';

const getButtonTextColor = (button, colors, state, disabled, mode) => {
  if (disabled && (state === ButtonType.link || state === ButtonType.grey)) {
    return mode === ThemeType.dark
      ? 'rgba(255, 255, 255, 0.20)'
      : colors.text.secondary;
  }
  return button[state].color;
};

const commonDisabledStyle = css`
  border-color: ${({ theme }) => theme.colors.border.primary};

  > span {
    color: ${({ theme }) => theme.colors.text.tertiary};
  }
`;

const buttonDisabledStyles = {
  [ButtonType.delete]: commonDisabledStyle,
  [ButtonType.edit]: commonDisabledStyle,
  [ButtonType.default]: css`
    background-color: #a5c5fc;
  `
};

export const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  box-sizing: border-box;
  text-align: center;
  padding: 10px 15px;
  white-space: nowrap;
  cursor: pointer;
  transition:
    background-color 0.2s ease-in-out,
    color 0.2s ease-in-out;

  ${({ theme, $isSmall, state, disabled, $bg }) => {
    const { borderRadius, fontFamily, button, colors } = theme;
    const width = $isSmall ? 'max-content' : '100%';
    const color = getButtonTextColor(
      button,
      colors,
      state,
      disabled,
      theme.mode
    );
    const styles =
      state === ButtonType.grey && theme.mode === ThemeType.dark
        ? { backgroundColor: 'rgba(255, 255, 255, 0.08)' }
        : {};

    return {
      ...button[state],
      width,
      borderRadius,
      fontFamily,
      color,
      backgroundColor:
        $bg || button[state].backgroundColor || button[state].background,
      ...styles
    };
  }}

  &:disabled {
    ${({ state }) =>
      (state !== ButtonType.link &&
        state !== ButtonType.grey &&
        buttonDisabledStyles[state]) ||
      buttonDisabledStyles.default}
  }

  &:hover {
    ${({ hover }) => hover || 'inherit'};
  }

  ${({ styles }) => styles}
`;

export const ButtonText = styled(Typography)`
  ${EllipsisText};
  ${({ theme: { button, colors, mode }, state, disabled }) => {
    const color = getButtonTextColor(button, colors, state, disabled, mode);
    return { ...button[state], color };
  }};
  transition: color 0.2s ease-in-out;
  background-color: initial;
`;

export const btnFixedAtBottomStyles = styles => css`
  width: calc(100% - 30px);
  position: fixed;
  bottom: env(safe-area-inset-bottom);
  margin: 15px 15px 20px;
  flex-grow: 1;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.11);
  ${styles}
`;
